// extracted by mini-css-extract-plugin
export var fullHeightState = "_3z-7";
export var headerCell = "_3z-1";
export var loadingStateCell = "_3z-4";
export var rowWrapper = "_3z-3";
export var standaloneTable = "_3z-8";
export var standaloneTableWithBodyFill = "_3z-9";
export var stateCell = "_3z-5";
export var table = "_3z-0";
export var tableBodyFiller = "_3z-6";
export var white = "_3z-2";